module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-content columns"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('p', [_c('strong', [_vm._v(_vm._s(_vm.post.title))]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(_vm.post.text) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "date"
  }, [_vm._v("On " + _vm._s(_vm.post.created_at))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 is-centered"
  }, [_c('a', {
    staticClass: "button is-danger is-outlined is-pulled-right",
    on: {
      "click": function($event) {
        _vm.removePost(_vm.index)
      }
    }
  }, [_vm._v("Delete")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ccf3fdec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PostItem.vue
// module id = 179
// module chunks = 1